import React, { Component } from 'react';
import { Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import { sortData } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import { getBackordersCaseTypes } from '../../utils/utils';

class BackordersCaseTypes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      backordersCaseTypes: [],
      selectedType: '',
      active: null
    };
  }

  componentDidMount = async () => {
    const {
      online, notify, setLoader, selectedProduct, selectedAccount
    } = this.props;
    setLoader(true);
    if (online) {
      const searchData = {};
      if (selectedProduct.length) {
        searchData.productNo = selectedProduct;
      }
      if (selectedAccount.length) {
        searchData.accountName = selectedAccount;
      }
      const backordersCaseTypesResponse = await getBackordersCaseTypes(searchData);
      const backordersCaseTypes = sortData(backordersCaseTypesResponse.data, 'CaseType').flatMap((caseType) => {
        if (caseType.CaseType.indexOf(';') !== -1) {
          return caseType.CaseType.split(';');
        }
        return [caseType.CaseType];
      });
      backordersCaseTypes && this.setState({
        backordersCaseTypes: backordersCaseTypes
          .filter((caseType, index) => backordersCaseTypes.indexOf(caseType) === index)
      });
    } else {
      notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 5 });
    }
    setLoader(false);
  }

  async UNSAFE_componentWillMount() {
    try {
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { backordersCaseTypes } = this.state;
    const { selectedCaseType, onSelectedCaseType, onBackFromFilters } = this.props;
    return (
      <section>
        <section className="section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ul className="select-list list-unstyled cursor-pointer">
                  {
                    backordersCaseTypes.length > 0
                      ? backordersCaseTypes.map((type, index) => (
                        <Link
                          key={index}
                          onClick={() => {
                            if (selectedCaseType.indexOf(type) === -1) {
                              onSelectedCaseType(type);
                            } else {
                              onBackFromFilters();
                            }
                          }}
                        >
                          <li>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100%' }}>
                                {type}
                              </div>
                              <i
                                className={selectedCaseType.indexOf(type) !== -1 ? 'fas fa-check' : ''}
                                style={{ width: '100%', textAlign: 'right', position: 'absolute' }}
                              />
                            </div>
                          </li>
                        </Link>
                      ))
                      : <div className="text-center">No case types available</div>
                  }
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withNotify(withLoader(BackordersCaseTypes));
